import { WithFetcherReady } from 'components/common/withFetcherReady';
import { WithSelectProject } from 'components/common/withSelectProject';
import type { ProjectLoadingGateProps } from 'components/common/withProjectLoader';
import React from 'react';
import { RouteProps } from 'react-router';
import { Navigate, useLocation } from 'react-router-dom';
import { debugLog } from 'shared/logger/debugLog';
import { useAuth0 } from '../../services/auth0/react-auth0.spa';
import { logError } from 'setup/logger/logError';

type PrivateRouteProps = Omit<RouteProps, 'element'> & {
  element: React.ComponentType<any>;
};
const PrivateRoute = ({
  element: Component,
  showsContentOnFailure,
}: PrivateRouteProps & ProjectLoadingGateProps): React.ReactElement | null => {
  const { isAuthenticated, loading } = useAuth0();
  const location = useLocation();

  debugLog(
    'PrivateRoute: is user authenticated? ',
    isAuthenticated,
    'loading:',
    loading
  );

  // Wait for Auth0 to finish initializing before making routing decisions
  if (loading || isAuthenticated === undefined) {
    return null;
  }

  if (!Component) {
    logError('PrivateRoute: Component is undefined!', { Component });
    return null;
  }

  if (!isAuthenticated) {
    const redirectLink = `${location.pathname}${location.search}`;
    return <Navigate to='/login' state={{ targetUrl: redirectLink }} />;
  }

  return (
    <WithSelectProject showsContentOnFailure={showsContentOnFailure}>
      <WithFetcherReady>
        <Component />
      </WithFetcherReady>
    </WithSelectProject>
  );
};

export const AnalyticsPrivateRoute = ({
  element: Component,
}: PrivateRouteProps): React.ReactElement | null => {
  const { isAuthenticated, loading } = useAuth0();
  const location = useLocation();

  !isAuthenticated &&
    debugLog(
      'AnalyticsPrivateRoute: user is not authenticated ',
      isAuthenticated,
      'loading:',
      loading
    );

  // Wait for Auth0 to finish initializing before making routing decisions
  if (loading || isAuthenticated === undefined) {
    return null;
  }

  if (!isAuthenticated) {
    const redirectLink = `${location.pathname}${location.search}`;
    return <Navigate to='/login' state={{ targetUrl: redirectLink }} />;
  }

  return <Component />;
};

export default PrivateRoute;
